import { ROUTES } from '../../../../modules/core';
import { BLACKLISTED_COUNTRY_CODES } from '../../../../store/features/system/constants';
import { getAngularService } from '../../../../modules/core';
export const shouldRedirectToBlacklist = async () => {
    const locationService = getAngularService('UserLocationDetails');
    const locationDetails = await locationService.getLocationDetails();
    const growthbook = getAngularService('growthbookFactory');
    const countryBlacklistFeature = await growthbook.getFeatureAsync('country_blacklist');
    if (countryBlacklistFeature.on) {
        const { location } = locationDetails;
        const countryCode = location.country_code;
        const hasAcknowledgedBlacklistedMessage = window.sessionStorage.getItem('hasAcknowledgedBlacklistedMessage');
        const redirectForBlacklist = hasAcknowledgedBlacklistedMessage !== 'true';
        const currentUrl = window.location.pathname || '';
        if (BLACKLISTED_COUNTRY_CODES.includes(countryCode) &&
            redirectForBlacklist &&
            currentUrl !== ROUTES.blacklistedPage()) {
            return true;
        }
    }
    return false;
};
export const redirectToBlacklistPage = () => {
    const currentPathname = window.location.pathname || '';
    const currentSearch = window.location.search || '';
    const currentUrl = currentPathname + currentSearch;
    history.pushState(null, null, `${ROUTES.blacklistedPage()}?redirect=${encodeURIComponent(currentUrl)}`);
};
